<template>
  <a-modal width="600px" v-model="isShow" :closable="false" :title="title" :afterClose="handleCancel"
           :maskClosable="false">
    <a-form-model ref="formDom" :model="formType" :rules="rulesType" :label-col="{ span: 5 }"
                  :wrapper-col="{ span: 19 }">
      <a-form-model-item label="类型名称" prop="name">
        <a-input v-model="formType.name" allowClear placeholder="请输入类型名称" style="width: 60%" />
      </a-form-model-item>
      <a-form-model-item label="类型格式" prop="format">
        <a-select v-model="formType.format" allowClear show-search option-filter-prop="children" placeholder="请选择"
                  style="width: 60%" @change="handleCancelCategory">
          <a-select-option v-for="item in FORMAT" :key="item.key" :value="item.key">{{
            item.value
          }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="状态">
        <a-radio-group v-model="formType.status">
          <a-radio :value="1">开启</a-radio>
          <a-radio :value="2">关闭</a-radio>
        </a-radio-group>
      </a-form-model-item>
    </a-form-model>
    <template slot="footer">
      <a-button key="back" @click="handleCancel"> 取 消 </a-button>
      <a-button key="submit" type="primary" :loading="btnloading" @click="handleSubmit"> 提 交 </a-button>
    </template>
  </a-modal>
</template>
<script>
import { reactive, toRefs, getCurrentInstance, defineComponent, onMounted, watch, computed } from '@vue/composition-api'
import { formType, rulesType } from './business/filialeList'
import dialog from '@/composables/dialog'
import compuedFun from './computed'
import api from '@/api/'
import storeGlobal from '@/store/'

const title = {
  Add: '新增',
  Edit: '编辑'
}

export default defineComponent({
  mixins: [dialog],
  props: {
    platformList: {
      type: Array,
      default: () => []
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props, { root }) {
    const _this = getCurrentInstance()
    const state = reactive({
      rulesType,
      title: title.Add,
      btnloading: false,
      principalList: [], // 负责人
      formType: { ...formType }
    })
    const labelList = computed(() => {
      return storeGlobal.state.label.data.WEBSITE.FREQUENCY_CONFIG_POPUP_TYPE
    })

    watch(
      () => _this.params,
      async () => {
        state.formType = JSON.parse(JSON.stringify({ ..._this.params }))
        const responsible = state.formType.responsible_name + '(' + state.formType.responsible_number + ')'
        _this.$set(state.formType, 'responsible', responsible)
      }
    )

    watch(
      () => _this.isEdit,
      async () => {
        state.title = _this.isEdit ? title.Edit : title.Add
      }
    )
    const methods = {
      handleSubmit() {
        state.btnloading = true
        _this.$refs.formDom.validate(async valid => {
          let res = null
          const data = { ...state.formType }
          if (valid) {
            if (_this.isEdit) {
              res = await api.contactTypeUpdate(data)
            } else {
              res = await api.contactTypeCreate(data)
            }
            if (_this.$validate(res)) {
              this.$message.success(_this.isEdit ? '编辑成功~' : '添加成功~')
              _this.isShow = false
              state.btnloading = false
              _this.$emit('handleOver')
              _this.$refs.formDom.resetFields()
            } else {
              state.btnloading = false
            }
          } else {
            this.$message.warning('请检查信息是否填写完成')
            state.btnloading = false
          }
        })
      },
      handleCancel() {
        _this.$refs.formDom.resetFields()
        _this.formType.status = 1
        _this.isShow = false
      },
      handleCancelCategory() {
        if (!_this.isEdit) {
          // _this.formType.typeids = []
        }
      }
    }
    return {
      ...toRefs(state),
      ...compuedFun(),
      ...methods,
      labelList
    }
  }
})
</script>
